import { Link } from "react-router-dom";
import styled, { css } from "styled-components"
import theme from "styled-theming";
import colors from "../styles/colors"
import { IVariantProps, ThemeType } from "../styles/theme";

export enum LinkTextColor {
    black = "black",
    white = "white",
    purple = "purple",
    purpleUnderline = "purpleUnderline"
}

const linkColor = theme.variants("mode", "variant", {
    [LinkTextColor.black]: {
        [ThemeType.light]: colors.black,
        [ThemeType.dark]: colors.white
    },
    [LinkTextColor.white]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.black
    },
    [LinkTextColor.purple]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.grey_2
    },
    [LinkTextColor.purpleUnderline]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.grey_2
    }
});

export const linkColorHover = theme.variants("mode", "variant", {
    [LinkTextColor.black]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.grey_2
    },
    [LinkTextColor.white]: {
        [ThemeType.light]: colors.purplePrimary,
        [ThemeType.dark]: colors.purplePrimary
    },
    [LinkTextColor.purple]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_1
    },
    [LinkTextColor.purpleUnderline]: {
        [ThemeType.light]: colors.purpleDark,
        [ThemeType.dark]: colors.grey_4
    }
});

const linkUnderlineColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.purpleTertiary
});

export const StyledLink = styled(Link)<IVariantProps<LinkTextColor>>`
    color: ${linkColor};
`;

// Anchor equivalent of StyledLink (same colors/styling) for full-page navigation, e.g. opening another bundle in a new tab.
export const StyledAnchor = styled.a<IVariantProps<LinkTextColor>>`
    color: ${linkColor};
`;

export const SmallStyledLink = styled(StyledLink)`
    font-size: var(--small-text-font-size);
    text-decoration-line: underline;
`

interface IAProps {
    variant?: LinkTextColor;
    disabled?: boolean;
}

export const A = styled.a<IAProps>`
    font-size: 1rem;
    font-family: "Gilroy-Regular", "regular-fallback";
    color: ${linkColor};
    ${props => props.variant === LinkTextColor.purpleUnderline && css`
        text-decoration: underline;
        text-decoration-color: ${linkUnderlineColor};
        text-underline-offset: .3rem;
    `}
    ${props => props.disabled && css`
        cursor: not-allowed;
        text-decoration: none;
    `}
    &:hover {
        color: ${linkColorHover};
    }

    span + i {
        margin-left: 4px;
    }
`;

export const SmallStyledA = styled(A)`
    font-size: 1rem;
    text-decoration-line: underline;
    ${props => props.disabled && css`
        cursor: not-allowed;
        text-decoration: none;
    `}
`;

A.defaultProps = {
    variant: LinkTextColor.purple
}

StyledLink.defaultProps = {
    variant: LinkTextColor.black
}

StyledAnchor.defaultProps = {
    variant: LinkTextColor.black
}
